export const ImgBaseUrl = 'https://resource.cctc.cc';
